import { z } from 'zod';
import { optionalEmail, optionalText, queryBoolean, requiredText } from './common';

// ---------------------------------------------------------------- Clientes

export const clientInputSchema = z.object({
  name: requiredText(200),
  taxId: optionalText(30),
  address: optionalText(200),
  postalCode: optionalText(20),
  city: optionalText(100),
  province: optionalText(100),
  country: optionalText(100),
  phone: optionalText(50),
  email: optionalEmail,
  notes: optionalText(2000),
  active: z.boolean().default(true),
});
export type ClientInput = z.input<typeof clientInputSchema>;
export type ClientData = z.output<typeof clientInputSchema>;

export const listClientsQuerySchema = z.object({
  q: z.string().trim().max(100).optional(),
  active: queryBoolean,
});
export interface ListClientsQuery {
  q?: string;
  active?: boolean;
}

export interface ClientDto {
  id: number;
  name: string;
  taxId: string | null;
  address: string | null;
  postalCode: string | null;
  city: string | null;
  province: string | null;
  country: string | null;
  phone: string | null;
  email: string | null;
  notes: string | null;
  active: boolean;
  createdAt: string;
  updatedAt: string;
  /** Palets actualmente en las instalaciones. */
  palletsInStock: number;
}

// ---------------------------------------------------------------- Mercancías

export const productInputSchema = z.object({
  name: requiredText(100),
  description: optionalText(500),
  active: z.boolean().default(true),
});
export type ProductInput = z.input<typeof productInputSchema>;
export type ProductData = z.output<typeof productInputSchema>;

export const listProductsQuerySchema = z.object({
  q: z.string().trim().max(100).optional(),
  active: queryBoolean,
});
export interface ListProductsQuery {
  q?: string;
  active?: boolean;
}

export interface ProductDto {
  id: number;
  name: string;
  description: string | null;
  active: boolean;
  createdAt: string;
  updatedAt: string;
  palletsInStock: number;
}
